// Utilities for working with time

// Function for converting time from "11:00 AM" to "11:00"
export const convertTimeToSimpleFormat = timeString => {
  if (!timeString) return timeString

  // If already in simple format "08:00", return as is
  if (!timeString.includes('AM') && !timeString.includes('PM')) {
    return timeString
  }

  // Parse "11:00 AM" or "11:03 PM"
  const [time, period] = timeString.split(' ')
  const [hours, minutes] = time.split(':').map(Number)

  let hour24 = hours
  if (period === 'PM' && hours !== 12) {
    hour24 = hours + 12
  } else if (period === 'AM' && hours === 12) {
    hour24 = 0
  }

  return `${hour24.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')}`
}

// Function for converting time from "08:00" to "08:00 AM"
export const convertTimeToDisplayFormat = timeString => {
  if (!timeString) return timeString

  // If already in AM/PM format, return as is
  if (timeString.includes('AM') || timeString.includes('PM')) {
    return timeString
  }

  // Parse "08:00"
  const [hours, minutes] = timeString.split(':').map(Number)

  let hour12 = hours
  let period = 'AM'

  if (hours === 0) {
    hour12 = 12
  } else if (hours === 12) {
    period = 'PM'
  } else if (hours > 12) {
    hour12 = hours - 12
    period = 'PM'
  }

  return `${hour12.toString().padStart(2, '0')}:${minutes
    .toString()
    .padStart(2, '0')} ${period}`
}
